import { render, staticRenderFns } from "./ClearPay.vue?vue&type=template&id=0b2107c6&"
import script from "./ClearPay.vue?vue&type=script&lang=js&"
export * from "./ClearPay.vue?vue&type=script&lang=js&"
import style0 from "./ClearPay.vue?vue&type=style&index=0&id=0b2107c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports